import { Pipe, PipeTransform } from '@angular/core';
import {Conversation} from "@twilio/conversations";

@Pipe({
  standalone: false,
  name: 'chatConversationSortPipe'
})
export class ChatConversationSortPipe implements PipeTransform {

  transform(conversations: Conversation[], sortBy: string, order?: string): unknown {
    return conversations.sort(function compare(a, b) {
      return (a.lastMessage?.dateCreated.getTime() || a.dateCreated.getTime()) - (b.lastMessage?.dateCreated.getTime() || b.dateCreated.getTime())
    }).reverse();
  }

}
